.wrapper {
	display: flex;
	flex-direction: column;
	gap: 4px;
}

.label {
	margin-bottom: unset !important;
}

.dropZone {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 8px;

	border: 1px dashed var(--border-hover);
	border-radius: 8px;
	background-color: var(--elevation-low);
	color: var(--content-primary);

	min-height: 140px;
	width: 100%;
	padding: 24px;

	cursor: default;
	transition:
		border-color 0.15s ease,
		background-color 0.15s ease;
}

.dropZone:focus-visible {
	outline: var(--focus-outline);
}

.dragging {
	border-color: var(--border-focus);
	background-color: var(--elevation-medium);
}

.invalid {
	border-color: var(--border-error);
}

/* Empty state */
.emptyState {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	text-align: center;
}

.dragText {
	color: var(--content-tertiary);
}

.browseButton {
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	color: var(--border-focus);
	text-decoration: underline;
}

.browseButton:focus-visible {
	outline: var(--focus-outline);
	border-radius: 2px;
}

.hint {
	color: var(--content-tertiary);
	margin-top: 4px;
}

/* Selected state */
.selectedState {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 8px;
	text-align: center;
}

.fileIcon {
	width: 24px;
	height: 24px;
	color: var(--content-tertiary);
}

.fileName {
	color: var(--content-primary);
	word-break: break-all;
}

.removeButton {
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	color: var(--content-error);
	text-decoration: underline;
}

.removeButton:focus-visible {
	outline: var(--focus-outline);
	border-radius: 2px;
}

.loading {
	cursor: progress;
}

.disabled {
	cursor: not-allowed;
}

.errorMessage {
	color: var(--content-error);
}

.spinner {
	width: 20px;
	height: 20px;
}
